import { Copy } from 'lucide-react';

interface FormatCellProps {
  label: string;
  value: string;
  cssValue?: string | null;
  copied?: boolean;
  onCopy?: () => void;
  actions?: React.ReactNode;
}

export function FormatCell({ label, value, cssValue, copied, onCopy, actions }: FormatCellProps) {
  return (
    <div
      className="format-cell"
      onClick={onCopy}
      role={onCopy ? 'button' : undefined}
      tabIndex={onCopy ? 0 : undefined}
      aria-label={onCopy ? `Copy ${label} value` : undefined}
    >
      <div className="format-cell__header">
        <span className="format-cell__label">{label}{actions}</span>
        <button
          className={`format-cell__copy-btn${copied ? ' format-cell__copy-btn--copied' : ''}`}
          onClick={(e) => { e.stopPropagation(); onCopy?.(); }}
          title="Copy to clipboard"
        >
          <Copy size={12} />
        </button>
      </div>
      <pre className="format-cell__value">{cssValue || value}</pre>
      {cssValue && value !== cssValue && (
        <pre className="format-cell__raw">{value}</pre>
      )}
    </div>
  );
}
